export function useIsBifrostEnabled(culture: string) {
    return ['en-au', 'en-us'].includes(culture.toLowerCase());
}

export function useIsMdsCtaEnabled(culture: string) {
    return culture.toLowerCase() !== 'en-in';
}
